export default function Skeleton({ width = '100%', height = '1rem', style = {} }) {
  return (
    <div
      className="aui-skeleton"
      style={{ width, height, ...style }}
      aria-hidden="true"
    />
  );
}
